import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import cn from "classnames";
import SideNav from "./Drawer";
import styles from "./Create.module.scss";
import { Spin } from "antd";

// import { endpoint, PostFunc } from './API';

const endpoint = `https://us-central1-draperu-talenter.cloudfunctions.net`;
const endpoint2 = `http://127.0.0.1:5001/draperu-talenter/us-central1`;

async function PostFunc(url) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };
  const response = await fetch(url, requestOptions);
  const data = await response.json();
  return data;
}

const FAQList = [
  { key: "q0", q: "" },
  { key: "q1", q: "How many years of experience do they have?" },
  {
    key: "q2",
    q: "Can you provide an overview of his professional background and experience?",
  },
  {
    key: "q3",
    q: "What specific skills or expertise does the candidate possess?",
  },
  { key: "q4", q: "Where is his current company?" },
  { key: "q5", q: "What is his current position?" },
  { key: "q6", q: "How many jobs did they have before?" },
  { key: "q7", q: "Please list all positions in his past experience." },
];

const getLinkedInId = (url) => {
  const regex =
    /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;
  /*`https://linkedin.com/in/t-sun`;*/
  let m;
  while ((m = regex.exec(url)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    console.log(m);
    return m.length == 6 ? m[5] : null;
    /*m.forEach((match, groupIndex) => {
      console.log(`Found match, group ${groupIndex}: ${match}`);
    });*/
  }
};

export default function Create(props) {
  const history = useHistory();
  const [statusMessage, setStatusMessage] = React.useState(0);
  const [email, setEmail] = React.useState(); //"chris.chang@pxcode.io"
  const [linkedInLink, setLinkedInLink] = React.useState(); // https://www.linkedin.com/in/
  const [githubUserName, setGithubUserName] = React.useState(''); // https://www.linkedin.com/in/


  useEffect(() => {    
    let c_email = localStorage.getItem("email");
    let c_linkedin = localStorage.getItem("linkedInId");
    let c_github = localStorage.getItem("githubId");
    if( c_email ) setEmail(c_email);
    if( c_linkedin ) setLinkedInLink(c_linkedin);
    if( c_github ) setGithubUserName(c_github);    
  }, [])

  const updateInputValueGithub = (evt) => {
    const val = evt.target.value;

    setGithubUserName(val);
  };

  const updateInputValue = (evt) => {
    const val = evt.target.value;
    const id = getLinkedInId(val);

    if (id != null) setLinkedInLink(id);
    else setLinkedInLink(val);
  };
  const updateInputEmail = (evt) => {
    const val = evt.target.value;
    setEmail(val);
  };
  const createResume = async (e) => {
    if( !email || !linkedInLink ) {
      alert('Please ensure you have input Email and LinkedIn ID');
      return;
    }
    setStatusMessage(1);

    const queryParameters = new URLSearchParams(window.location.search)
    const override = queryParameters.get('enforce') ? true : false;
    

    let url1 = `${endpoint}/linkedin?email=${email}&q=${linkedInLink}`;
    if( override ) {
      url1 += `&enforce=true`
    }
    let url2 = `${endpoint}/github?email=${email}&user=${githubUserName}`
    if( override ) {
      url2 += `&enforce=true`
    }

    const [json, json2] = await Promise.all([
      PostFunc(url1),
      githubUserName
        ? PostFunc(url2)
        : Promise.resolve(""),
    ]);
    // const json = await PostFunc(
    //   `${endpoint}/linkedin?email=${email}&q=${linkedInLink}`
    // );
    console.log(json);
    console.log(json2);
    setStatusMessage(0);
    alert("Congratulations, your virtual profile has successfully created.");

    localStorage.setItem("email", email);
    localStorage.setItem("tal_id", json.id);
    localStorage.setItem("linkedInId", linkedInLink);
    if(githubUserName)
      localStorage.setItem("githubId", githubUserName);

    history.push(`/Interview/${json.id}`);
  };

  return (
    <React.Fragment>
      <div
        style={{
          "--src": `url(${require("assets/ae6fd747cc091af25bffbb49df2a3e17.png")})`,
        }}
        className={cn(styles.root, "create")}
      >
        <div className={styles.flex_col}>
          <h1 className={styles.hero_title}>Get Started</h1>

          <div className={styles.content_box7}>
            <div className={styles.flex_col1}>
              <div className={styles.flex_row}>
                <div className={styles.flex_row__cell}>
                  <h2 className={styles.medium_title}>Email*</h2>
                </div>
                <div className={styles.flex_row__spacer} />
                <div className={styles.flex_row__cell1}>
                  <div className={styles.content_box}>
                    <h4 className={styles.highlights_box}>
                      <input
                        className={styles.highlights}
                        value={email}
                        onChange={(evt) => updateInputEmail(evt)}
                        type={"text"}
                        placeholder={`Please Input your Email`}
                      />
                    </h4>
                  </div>
                </div>
              </div>

              <div className={styles.flex_col1__cell}>
                <hr size={1} className={styles.line} />
              </div>
              <div className={styles.flex_col1__cell1}>
                <div className={styles.flex_row1}>
                  <div className={styles.flex_row1__cell}>
                    <h2 className={styles.medium_title1}>LinkedIn*</h2>
                  </div>
                  <div className={styles.flex_row1__spacer} />
                  <div className={styles.flex_row1__cell1}>
                    <div className={styles.content_box}>
                      <h4 className={styles.highlights1_box}>
                        <input
                          className={styles.highlights1}
                          value={linkedInLink}
                          onChange={(evt) => updateInputValue(evt)}
                          type={"text"}
                          placeholder={`Please Input LinkedIn ID`}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <hr size={1} className={styles.line} />

              <div className={styles.flex_row2}>
                <div className={styles.flex_row2__cell}>
                  <h2 className={styles.medium_title2}>Github</h2>
                </div>
                <div className={styles.flex_row2__spacer} />
                <div className={styles.flex_row2__cell1}>
                  <div className={styles.content_box}>
                    <h4 className={styles.highlights1_box}>
                      <input
                        value={githubUserName}
                        onChange={(evt) => updateInputValueGithub(evt)}
                        className={styles.highlights1}
                        type={"text"}
                        placeholder={`Please Input your Github Link`}
                      />
                    </h4>
                  </div>
                </div>
              </div>

              <hr size={1} className={styles.line} />
              <div className={styles.flex_col1__cell2}>
                <div className={styles.flex_row3}>
                  <div className={styles.flex_row3__cell}>
                    <h2 className={styles.medium_title2}>Twitter</h2>
                  </div>
                  <div className={styles.flex_row3__spacer} />
                  <div className={styles.flex_row3__cell1}>
                    <div className={styles.content_box}>
                      <h4 className={styles.highlights1_box}>
                        <input
                          className={styles.highlights1}
                          type={"text"}
                          placeholder={`Please Input your twitter Link`}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_col1__cell2}>
                <hr size={1} className={styles.line1} />
              </div>
              <div className={styles.flex_col1__cell2}>
                <div className={styles.flex_row4}>
                  <h2 className={styles.medium_title3}>CV pdf</h2>
                  <div className={styles.flex_row4__spacer} />

                  <div className={styles.flex_row5}>
                    <h2 className={styles.medium_title11}>upload.pdf</h2>
                    <div className={styles.flex_row5__spacer} />

                    <div className={styles.content_box3}>
                      <img
                        src={require("assets/0b113f3abdaad822f87312da670b6027.png")}
                        alt="alt text"
                        className={styles.icon}
                      />
                    </div>

                    <div className={styles.flex_row5__spacer1} />

                    <div className={styles.content_box4}>
                      <img
                        src={require("assets/d63b38a76af138cbc31b7d4fbd2103ec.png")}
                        alt="alt text"
                        className={styles.icon}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_col1__cell2}>
                <hr size={1} className={styles.line11} />
              </div>
              <div className={styles.flex_col1__cell2}>
                <div className={styles.flex_row6}>
                  <h2 className={styles.medium_title4}>Image</h2>
                  <div className={styles.flex_row6__spacer} />

                  <div className={styles.flex_row5}>
                    <h2 className={styles.medium_title12}>image.jpg</h2>
                    <div className={styles.flex_row5__spacer2} />

                    <div className={styles.content_box6}>
                      <img
                        src={require("assets/0b113f3abdaad822f87312da670b6027.png")}
                        alt="alt text"
                        className={styles.icon1}
                      />
                    </div>

                    <div className={styles.flex_row5__spacer3} />

                    <div className={styles.content_box5}>
                      <img
                        src={require("assets/d63b38a76af138cbc31b7d4fbd2103ec.png")}
                        alt="alt text"
                        className={styles.icon1}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_col1__cell2}>
                <hr size={1} className={styles.line11} />
              </div>
            </div>
          </div>

          <div className={styles.flex_col__cell}>
            {statusMessage ? (
              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <button
                style={{
                  "--src": `url(${require("assets/4113fa164478c27777b67a00435db3ee.png")})`,
                }}
                className={styles.btn}
                onClick={createResume}
              >
                <span className={styles.btn__text}>Create Virtual Resume</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
